import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { getParticipantPhotos } from "../../../apis/actions/participants.actions";
import DotsLoader from "../../../biblio/Loader/DotsLoader";
import Selects from "../../../biblio/Selects/Selects";
import PaginationComponent from "../../../biblio/Pagination/PaginationComponent";
import { getDateRange, scroll } from "../../../components/utils/utils";
import CustomConfigProvider from "../ProfileHeader";
import ParticipantMediaCollapse from "../ParticipantMediaCollapse";

const ParticipantPhotos = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [state, setState] = useState({
    year: "",
    month: "",
  });
  const [participantId, setParticipantId] = useState<number | null>(null);
  const itemPerPage = 5;

  const { photos, photosTotalPages, photoParticipants, loading } = useSelector(
    (state: RootState) => state?.participants
  );
  useEffect(() => {
    setCurrentPage(1);
  }, [state, participantId]);
  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      getParticipantPhotos({
        participant_id: participantId,
        limit: itemPerPage,
        page: currentPage,
        date_from: date_from,
        date_to: date_to,
      })
    );
  }, [dispatch, currentPage, state, participantId]);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  const isFiltered = state.year !== "" || participantId !== null;

  return (
    <>
      <CustomConfigProvider
        title="الصور"
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
      >
        <Selects
          options={photoParticipants}
          selectPlaceholder="المتبرع"
          onChange={(value: any) => setParticipantId(value?.value ?? null)}
          allowClear={true}
          className="takaful--service-select takaful--request-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : !photos?.length ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          {isFiltered
            ? "لا توجد صور تتوافق مع البحث الذي قمت به"
            : "لا توجد صور"}
        </p>
      ) : (
        <div ref={currentRef}>
          <ParticipantMediaCollapse
            groups={photos}
            loading={loading}
            isVideo={false}
            emptyText="لا توجد صور"
          />
          <div className="takaful--pagination-container">
            {photosTotalPages > 1 && (
              <PaginationComponent
                active={currentPage}
                total={photosTotalPages * itemPerPage}
                itemPerPage={itemPerPage}
                scroll={() => scroll(currentRef)}
                setActive={(nb) => updateActive(nb)}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ParticipantPhotos;
